import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import ContactForm from '@ep/components/ContactForm';
import NewContactForm from '@ep/components/ContactForm/NewContactForm';
import { H1, Subhead2 } from '@ep/components/Typography';
import Close from '@ep/images/close.svg';
import Error from '@ep/images/error.svg';
import icons from '@ep/images/icons';
import Success from '@ep/images/success.svg';
import theme from '@ep/theme';
import getHtmlProp from '@ep/utils/getHtmlProp';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import { S_IFCHR } from 'constants';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
interface ContactUsModalProps {
  open: boolean;
  onClose: () => void;
}

// This has a "magic number" based on the height of the contact form
const StyledModal = styled(Modal)`
  display: flex;
  align-items: start;
  justify-content: center;
  overflow-y: scroll;

  @media (min-height: 1000px) {
    align-items: center;
  }
`;

const ModalContainer = styled.div`
  margin-top: 50px;
  overflow: hidden;
  border-radius: 15px;
  position: relative;
  width: 70%;
  min-height: 45rem;
  background-color: ${theme.colors.white};
  outline: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${theme.mediaQueries.mobileAndTablet} {
    width: 100%;
    height: 100%;
    border-radius: 0px;
    margin-top: 0px;
    overflow-y: scroll;
  }
  ${theme.mediaQueries.mobile} {
    min-height: 0;
  }
`;

const CloseButton = styled(Button)`
  width: 2rem;
  height: 2rem;
  padding: 0;
  line-height: 0.5;
  background-color: transparent;
  border-radius: 50%;
  border-width: 2px;
  outline: none;
  margin-right: 1rem;
  &:hover {
    background-color: transparent !important;
    border-color: #00273f !important;
  }
  svg {
    width: 1rem;
    height: 1rem;
  }
  ${theme.mediaQueries.mobile} {
    grid-row: 1;
  }
`;

const BackButton = styled(Button)`
  color: ${theme.colors.white};
  background-color: ${theme.colors.oceanBlue};
  border: none;
  outline: none;
  &:hover {
    color: ${theme.colors.white};
    background-color: transparent !important;
    border-color: transparent !important;
  }
  svg {
    transform: scaleX(-1);
  }
  ${theme.mediaQueries.mobile} {
    grid-row: 1;
    height: 3rem;
    width: 10rem;
  }
`;

const ModalHeader = styled.div`
  /* border-radius: 15px 15px 0px 0px;  */
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: ${theme.colors.oceanBlue};
  h1:last-child {
    margin: 0;
    margin-bottom: none;
  }
  h1 {
    color: ${theme.colors.white};
    font-family: ${theme.typography.secondaryFont.light};
    font-size: 2rem;
  }
  ${theme.mediaQueries.mobile} {
    h1 {
      font-size: 1.3rem;
    }
    display: grid;
  }
`;

const HeaderTitle = styled.div`
  margin-top: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.white};
  font-family: ${theme.typography.secondaryFont.light};
  font-size: 2rem;
`;

const ContactFormFooter = styled.div`
  width: 100%;
  height: 4em;
  background-color: ${theme.colors.duskBlue};
`;

const Heading = styled(H1)`
  align-self: center;
  margin: 10px 0px 10px 0px !important;
  font-size: 2rem;
  ${theme.mediaQueries.mobile} {
    font-size: 1.5rem;
    text-align: center;
  }
`;

const IconWrapper = styled.div`
  margin-right: 1rem;
  display: flex;
  align-items: center;
    ${theme.mediaQueries.mobile} {
      display: none;
    }
`;

function ContactUsModal({ open, onClose }: ContactUsModalProps) {
  // const data = useStaticQuery(
  //   graphql`
  //     query {
  //       site {
  //         siteMetadata {
  //           contactUsData {
  //             heading
  //             subheading
  //             sendingHeading
  //             sendingSubheading
  //             successHeading
  //             successSubheading
  //             errorHeading
  //             errorSubheading
  //           }
  //         }
  //       }
  //     }
  //   `,
  // );

  // const {
  //   heading,
  //   subheading,
  //   sendingHeading,
  //   sendingSubheading,
  //   successHeading,
  //   successSubheading,
  //   errorHeading,
  //   errorSubheading,
  // } = data.site.siteMetadata.contactUsData;

  const currentUrl =
    typeof window !== 'undefined' ? window.location.pathname : '';
  const currentPath = currentUrl.replace(/\//g, '');
  let initialHeader: string = '';
  let initialIcon: string = '';
  let initialType: string = '';
  let initialCard: number = 1;

  //  if (currentPath.includes('incentives') || currentPath.includes('tax')) {
  //    initialHeader = 'New Products, Services, and Incentives';
  //    initialIcon = 'SalesInquiries';
  //    initialType = 'SICard';
  //    initialCard = 3;
  //  } else {
  initialHeader = 'How can we help you?';
  initialIcon = '';
  initialType = '';
  initialCard = 1;
  //  }

  const [cardState, setCardState] = useState({
    header: initialHeader,
    icon: initialIcon,
    type: initialType,
    card: initialCard,
  });

  const HandleClose = () => {
    history.pushState(
      '',
      document.title,
      window.location.pathname + window.location.search,
    );
    // dataLayer.push({
    //   event:
    //     'Contact form closed - ' +
    //     cardState.header +
    //     ' - card ' +
    //     cardState.card,
    // });
    onClose();
    setCardState({
      header: 'How can we help you?',
      icon: '',
      type: '',
      card: 1,
    });
  };

  const HandleBack = () => {
    if (cardState.card === 1) {
      // dataLayer.push({
      //   event:
      //     'Contact form closed - ' +
      //     cardState.header +
      //     ' - card ' +
      //     cardState.card,
      // });
      onClose();
      setCardState({
        header: 'How can we help you?',
        icon: '',
        type: '',
        card: 1,
      });
    } else if (cardState.card === 2) {
      setCardState({
        header: 'How can we help you?',
        icon: '',
        type: '',
        card: 1,
      });
    } else {
      setCardState({
        ...cardState,
        card: cardState.card - 1,
      });
    }
  };
  let Icon = icons[cardState.icon];
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      role="complementary"
      disableBackdropClick={true}
    >
      <Fade in={open}>
        <ModalContainer>
          <ModalHeader>
            <BackButton
              icon="Arrow"
              color="gray"
              outlined
              label={`Back`}
              onClick={() => HandleBack()}
            />
            <CloseButton
              color="gray"
              outlined
              onClick={() => HandleClose()}
              aria-label="Close"
              label={<Close />}
            />
          </ModalHeader>
          <HeaderTitle>
            {cardState.icon.length > 0 && <IconWrapper><Icon /></IconWrapper>} 
            {cardState.header === 'Product Support' ? (
              <Heading style={{ marginLeft: '1rem' }}>    
                {cardState.header}
              </Heading>
            ) : (
              <Heading>{cardState.header}</Heading>
            )}
          </HeaderTitle>
          <NewContactForm
            handleCloseContact={() => HandleClose()}
            cardState={cardState.type + cardState.card}
            setCardState={setCardState}
            isModal={true}
          />
          <ContactFormFooter />
        </ModalContainer>
      </Fade>
    </StyledModal>
  );
}

export default ContactUsModal;
